// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  no: `छैन`,
  select_country_code: `देश कोड चयन गर्नुहोस्`,
  balance: `सन्तुलन`,
  requirement: `आवश्यकता`,
  deposit_from_bank: `बैंकबाट निक्षेप`,
  game: `खेल`,
  games: `खेलहरू`,
  sport: `खेलकुद`,
  center: `केन्द्र`,
  mines: `खानीहरू`,
  crash: `क्र्यास`,
  lucky_colour: `भाग्यशाली रंग`,
  dice: `पासा`,
  limbo: `लिम्बो`,
  lucky_gift: `भाग्यशाली उपहार`,
  all_games: `सबै खेलहरू`,
  game_history: `खेल इतिहास`,
  coupon_code: `कुपन कोड`,
  telegram: `टेलिग्राम`,
  customer_service: `ग्राहक सेवा`,
  player: `खेलाडी`,
  winner: `विजेता`,
  all_bets: `सबै बेट्स`,
  my_bets: `मेरो बेट्स`,
  name: `नाम`,
  time: `समय`,
  bet_amount: `शर्त रकम`,
  prediction: `भविष्यवाणी`,
  payout: `भुक्तानी`,
  login: `लगइन`,
  register: `दर्ता गर्नुहोस्`,
  username_placeholder: `प्रयोगकर्ता नाम`,
  please_input_your_x: `कृपया आफ्नो {{x}} प्रविष्ट गर्नुहोस्।`,
  affiliate_referral: `सम्बद्ध / सिफारिस ID (ऐच्छिक)`,
  captcha: `क्याप्चा`,
  forgot_password: `पासवर्ड बिर्सनुभयो`,
  minor_note: `यो साइट भ्रमण गर्न, तपाईं १८ वर्ष माथिको हुनुहुन्छ र सहमत हुनुहुन्छ भनी सुनिश्चित गर्नुहोस्।`,
  terms_of_service: `सेवाका सर्तहरू`,
  by_signing_in: 'साइन इन वा साइन अप गरेर, तपाईं हाम्रो',
  dont_have_account: `खाता छैन?`,
  sign_up: `साइन अप गर्नुहोस्`,
  username: `प्रयोगकर्ता नाम`,
  email: `इमेल`,
  full_name: `पूरा नाम`,
  confirm_18: `दर्ता गर्नुहोस् बटन क्लिक गरेर, म यसद्वारा स्वीकार गर्दछु कि म १८ वर्ष भन्दा माथिको छु र मैले तपाईंको पढेको र स्वीकार गरेको छु`,
  already_have_account: `पहिले नै खाता छ?`,
  share: `सेयर`,
  deposit: `जम्मा`,
  promos: `प्रचारहरू`,
  bonus: `बोनस`,
  app: `एप`,
  load_more: `थप लोड गर्नुहोस्`,
  details: `विवरणहरू`,
  helps: `मद्दत गर्छ`,
  kyc_policy: `केवाईसी नीति`,
  privacy_policy: `गोपनीयता नीति`,
  responsible_gaming: `जिम्मेवार खेल`,
  terms_and_condition: `नियम र सर्त`,
  faq: `FAQ`,
  about_us: `हाम्रो बारेमा`,
  amount: `रकम`,
  minimum: `न्यूनतम`,
  maximum: `अधिकतम`,
  enter_amount: `रकम प्रविष्ट गर्नुहोस्`,
  extra: `अतिरिक्त`,
  deposit_bonus: `जम्मा बोनस`,
  do_not_participate: `पदोन्नतिमा भाग नलिने`,
  payment_problem: `भुक्तानी समस्या`,
  click_for_help: `मद्दतको लागि क्लिक गर्नुहोस्`,
  deposit_notes: `जम्मा नोटहरू`,
  available_balance: `उपलब्ध ब्यालेन्स`,
  withdraw: `फिर्ता लिनुहोस्`,
  withdrawal_notes: `निकासी नोटहरू`,
  withdrawal_note1: `हालको निकासी संख्या`,
  withdrawal_note1_1: `vip`,
  withdrawal_note2: `निकासी शुल्क:`,
  min: `न्यूनतम:`,
  max: `अधिकतम:`,
  opening_times: `खुल्ने समय:`,
  withdrawal_note3: `१. १० मिनेट भित्र सबैभन्दा छिटो निकासी समय`,
  withdrawal_note4: `२. तपाईंको निकासी जानकारी सही छ भनी सुनिश्चित गर्नुहोस्, यदि निकासी जानकारी गलत छ भने, यसले तपाईंको कोष गुमाउन सक्छ।`,
  withdrawal_note5: `३. यदि तपाईंसँग कुनै प्रश्न छ भने कृपया हामीलाई सम्पर्क गर्न नहिचकिचाउनुहोस्।`,
  notifications: `सूचनाहरू`,
  invalid_x: `अमान्य {{x}}`,
  captcha_not_match: `क्याप्चा मिल्दैन`,
  invalid_x_must_be_atleast_y_characters: `अमान्य {{x}}, कम्तिमा {{y}} वर्णहरू हुनुपर्छ।`,
  x_is_required: `{{x}} आवश्यक छ`,
  phone_number: 'फोन नम्बर',
  phone_num_x_max: `फोन नम्बरको अधिकतम {{x}} अंकहरू`,
  email_sent: `इमेल पठाइयो, कृपया आफ्नो इमेल जाँच गर्नुहोस्।`,
  enter_valid_email: `कृपया मान्य इमेल प्रविष्ट गर्नुहोस्।`,
  confirm: `पुष्टि गर्नुहोस्`,
  password_atleast_6_characters: `पासवर्ड कम्तिमा ६ अक्षरको हुनुपर्छ।`,
  password_reset_success: `पासवर्ड रिसेट सफल भयो!।`,
  new_password: `नयाँ पासवर्ड`,
  bank: 'बैंक',
  bank_transfer: `बैंक स्थानान्तरण`,
  bank_name: `बैंक नाम`,
  account_name: `खाता नाम`,
  account_number: `खाता नम्बर`,
  pix_number: `PIX नम्बर`,
  drop_or_select: `फाईल छोड्नुहोस् वा चयन गर्नुहोस्`,
  drop_files_here: `फाइलहरू यहाँ छोड्नुहोस्`,
  transfer_to: `मा स्थानान्तरण गर्नुहोस्`,
  upload_receipt: `रसिद अपलोड गर्नुहोस्`,
  select_bonus: `बोनस चयन गर्नुहोस्`,
  no_promotion: `कुनै पदोन्नति छैन`,
  please_upload_receipt: `कृपया रसिद अपलोड गर्नुहोस्`,
  bank_account: `बैंक खाता`,
  add_account: `खाता थप्नुहोस्`,
  account_holder_name: `खाता धारकको नाम`,
  name_of_the_account_holder: `खातावालाको नाम`,
  fill_in_bank_account: `बैंक खाता भर्नुहोस्`,
  withdraw_information: `जानकारी फिर्ता लिनुहोस्`,
  note: `नोट`,
  amount_withdrawn: `रकम फिर्ता`,
  amount_no_exceed_balance: `निकासी रकम उपलब्ध मौज्दात भन्दा बढी हुनु हुँदैन`,
  minimum_withdraw_amount_is_x: `न्यूनतम निकासी रकम {{x}} हो।`,
  transaction_history: `लेनदेन इतिहास`,
  date_from: `मिति देखि`,
  date_to: `मिति सम्म`,
  account_name_must_be_4: `खाताको नाम ४ भन्दा बढी लम्बाइको हुनुपर्छ।`,
  account_number_must_be_x: `खाता नम्बर १०-१४ लम्बाइको हुनुपर्छ।`,
  minimum_length_is_x: `न्यूनतम लम्बाइ {{x}} हो`,
  maximum_length_is_x: `अधिकतम लम्बाइ {{x}} हो`,
  payment_method: `भुक्तानी विधि`,
  mode: `मोड`,
  no_bank_account: `तपाईंसँग झिक्नको लागि कुनै खाता छैन, अहिले नै थप्नुहोस्।`,
  please_select_bank: `कृपया बैंक खाता चयन गर्नुहोस्`,

  bet_history: `शर्त इतिहास`,
  game_provider: `खेल प्रदायक`,
  bet_count: `शर्त गणना`,
  win_loss: `जित/हार`,
  rebate: `छूट`,
  turnover: `कारोबार`,
  game_category: `खेल कोटि`,

  you_have_x_unread_messages: `तपाईंसँग {{x}} नपढिएका सन्देशहरू छन्।`,
  deposit_amount_between_x_and_y: `निक्षेप रकम {{x}} र {{y}} को बीचमा हुनुपर्छ।.`,
  minimum_amount_is_x_y: `न्यूनतम रकम {{x}}{{y}} हो`,

  // all
  all: `सबै`,
  title: `शीर्षक`,
  date: `मिति`,
  type: `टाइप गर्नुहोस्`,
  status: `स्थिति`,
  remark: `टिप्पणी`,
  category: `श्रेणी`,
  please_select_x: `कृपया {{x}} चयन गर्नुहोस्`,
  save: `बचत गर्नुहोस्`,

  change_password: `पासवर्ड परिवर्तन गर्नुहोस्`,
  current_password: `हालको पासवर्ड`,
  confirm_password: `नयाँ पासवर्ड पुष्टि गर्नुहोस्`,
  submit: `पेश गर्नुहोस्`,
  password_changed: `पासवर्ड परिवर्तन भयो`,
  x_must_be_y_characters: `{{x}} कम्तिमा {{y}} वर्णहरूको हुनुपर्छ।`,
  reset_password: `पासवर्ड रिसेट गर्नुहोस्`,
  casino: `क्यासिनो`,
  slots: `स्लटहरू`,
  live_casino: `लाइभ क्यासिनो`,
  fishing: `माछा मार्ने`,
  sports: `खेलकुद`,
  cards: `कार्डहरू`,
  clear: `स्पष्ट`,
  search: `खोज्नुहोस्`,
  new: `नयाँ`,
  logout: `लगआउट`,
  choose_date: `मिति छान्नुहोस्`,
  select_both_date: `मिति देखि र मिति सम्म दुवै चयन गर्नुहोस्`,
  from: `बाट`,
  to: `को`,
  apply: `आवेदन दिनुहोस्`,
  promotions: `प्रचारहरू`,
  learn_more: `थप जान्नुहोस्`,
  password_doesnt_match: `पासवर्ड मेल खाँदैन।`,
  cancel: `रद्द गर्नुहोस्`,
  confirm_to_pay: `भुक्तानी गर्न पुष्टि गर्नुहोस्`,
  deposit_amount: `जम्मा रकम`,
  loading_please_wait: `लोड हुँदैछ, कृपया प्रतीक्षा गर्नुहोस्`,
  account: `खाता`,
  profile: `प्रोफाइल`,
  bank_list: `बैंक सूची`,
  in_maintenance: `मर्मतसम्भारमा`,
  birthday: `जन्मदिन`,
  birthday_bonus: `बोनसको लागि आफ्नो जन्मदिन प्रविष्ट गर्नुहोस्! 🎉🎁`,
  referral_code: `रेफरल कोड`,
  referral: `रेफरल`,
  my_referral: `मेरो रेफरल`,
  my_claim: `मेरो दावी`,
  claim_profit: `नाफा दाबी गर्नुहोस्`,
  available_profit: `उपलब्ध लाभ`,
  claimed_profit: `नाफा दावी गरेको छ`,
  all_time_profit: `सबै समय लाभ`,
  referral_note_on_x: `तपाईंका साथीहरूले {{x}} मा खेल्दा हरेक पटक नाफा कमाउनुहोस्।`,
  tier: `टियर`,
  commission: `आयोग`,
  referred_member: `उल्लेखित सदस्य`,
  profit_earned: `नाफा कमाइयो`,
  account_information: `खाता जानकारी`,
  invite_friends: `साथीहरूलाई आमन्त्रित गर्नुहोस्`,
  how_it_work: `यसले कसरी काम गर्छ?`,
  invite_note: `तपाईंको साथीले तपाईंको रेफरल कोड प्रयोग गरेर साइन अप गर्दा विशेष रेफरल बोनसहरू पाउनुहोस्!`,
  share_via: `मार्फत साझेदारी गर्नुहोस्`,
  referral_link: `रेफरल लिङ्क`,
  total_profit: `कुल लाभ`,
  copied: `प्रतिलिपि गरियो`,
  nothing_to_claim: `दावी गर्न केहि छैन`,
  claim_history: `दावी इतिहास`,
  downline: `मेरो डाउनलाइन`,
  last_x_digit_bank_ref_number: `बैंक रेफरेन्स नम्बरको अन्तिम {{x}} अंक`,
  bank_ref_number_validation_x: `बैंक रेफरेन्स नम्बर आवश्यक छ र {{x}} वर्ण लम्बाइको हुनुपर्छ।`,
  sort: 'क्रमबद्ध गर्नुहोस्',
  login_directly: `सिधै लगइन गर्नुहोस्`,
  our_game_provides: `हाम्रा खेल प्रदायकहरू`,
  we_accept_below_bank: `हाम्रा खेलहरू सजिलो हुन्छ`,
  we_accept_payment_methods: `हामी भुक्तानी विधि स्वीकार गर्छौं`,
  refer_and_reward: `सन्दर्भ र पुरस्कार`,
  linked_successfully_x: `{{x}} सँग सफलतापूर्वक लिङ्क गरियो! कृपया पहिलो पटक आफ्नो खाता दर्ता गर्नुहोस्।`,
  more_x_of_y: `थप {{x}}/{{y}}`,
  default: `पूर्वनिर्धारित`,
  promotion: `पदोन्नति`,
  daily_mission: 'दैनिक मिशन',
  agent: 'एजेन्ट',
  contact_us: 'हामीलाई सम्पर्क गर्नुहोस्',
  download: 'डाउनलोड गर्नुहोस्',
  cash_claim: 'नगद दाबी',
  demo: 'डेमो',
  favorites: 'मनपर्नेहरू',
  popular: 'लोकप्रिय',
  claim_bonus: `बोनस दाबी गर्नुहोस्`,
  insufficient_balance: `अपर्याप्त ब्यालेन्स`,
  currently_displaying: 'हाल {{z}} मध्ये {{x}} {{y}} खेलहरू प्रदर्शन गर्दै।',
  all_x: 'सबै {{x}}',
  no_results: 'कुनै परिणाम फेला परेन',
  search_games: 'खेलहरू खोज्नुहोस्',
  please_scan_using_your: `कृपया आफ्नो प्रयोग गरेर स्क्यान गर्नुहोस्`,
  vip_level: `VIP स्तर`,
  bonus_direct: `प्रत्यक्ष बोनस`,
  rebate_level: `छूट स्तर`,
  vip_header: `Jit993 मा स्लट मेसिनहरू, बोर्ड र कार्ड गेमहरू, फिसिङ, भिडियो, खेलकुद र लट्री खेलहरूमा गरिएको सबै सट्टाबाजी स्थायी रूपमा जम्मा गरिनेछ। मान्य सट्टाबाजी = स्थायी आम्दानी र धन भाग्य!`,
  vip_example: `
 उदाहरण १:

जुन सदस्यहरूको जम्मा निक्षेप १ मिलियन पुग्छ, उनीहरू VIP स्तर २ मा पुग्छन्, R$210 बोनस प्राप्त गर्छन् र 3.50% रिबेट पाउँछन्।
जब जम्मा निक्षेप ६ मिलियन पुग्छ, उनीहरू VIP स्तर ३ मा पुग्छन्, R$800 बोनस प्राप्त गर्छन् र 4% रिबेट पनि पाउँछन्।`,
  activity_rules: `गतिविधि नियम:`,
  activity_rules_1: `१. निकासी अनुरोध गर्न सबै बोनसहरूमा x3 रोलओभर हुनु आवश्यक छ।`,
  activity_rules_2: `२. कृपया समयसीमा भित्र छुट बोनस दाबी गर्नुहोस्, यदि तपाईं ढिलो हुनुभयो भने, यसलाई परित्याग मानिनेछ;`,
  activity_rules_3: `३. गतिविधिहरूमा सदस्यहरूको सहभागिता प्रणालीद्वारा स्वचालित रूपमा गणना गरिन्छ, यदि कुनै आपत्ति छ भने, Jit993 को अनुसन्धानको नतिजालाई मान्यता दिइनेछ;`,
  activity_rules_4: `४. यदि तपाईंले आफ्नो सदस्य खाता/पासवर्ड बिर्सनुभयो भने, कृपया आफ्नो खाता जानकारी पुन: प्राप्ति गर्न मद्दतको लागि "२४-घण्टा अनलाइन ग्राहक सेवा" मा सम्पर्क गर्नुहोस्;`,
  activity_rules_5: `५. Jit993 ले कुनै पनि समयमा यो प्रवर्द्धन परिवर्तन गर्ने, रोक्ने वा रद्द गर्ने अधिकार सुरक्षित राख्छ।`,
  activity_rules_6: `६. नि:शुल्क खेल बचत नगर्नुहोस्, नि:शुल्क खेल किन्नुहोस्`,
  activity_rules_7: `७. कुनै पनि बोनससँग संयोजन गर्न सकिँदैन`,
  activity_rules_8: `८. प्रति निक्षेप अधिकतम निकासी R$१००.०००.०० हो।`,
  event_instructions: 'घटना निर्देशनहरू',
  agent_p1: 'एपहरू र सामाजिक सञ्जालहरूमा आफ्नो अद्वितीय लिङ्क साझा गर्नुहोस्',
  agent_p2:
    'फेसबुक, इन्स्टाग्राम, टिकटक, टेलिग्राम, व्हाट्सएप, युट्युब, लगायत, हतार गर्नुहोस् र सबैलाई आमन्त्रित गर्नुहोस्, तपाईंको विशेष लिङ्क मार्फत दर्ता गर्ने सदस्यहरू तपाईंको प्रत्यक्ष एजेन्ट बन्नेछन्। तर ध्यान दिनुहोस् किनभने तपाईंले आमन्त्रित गर्ने नयाँ सदस्यहरू वास्तविक र मान्य हुनुपर्छ।',
  agent_step1:
    'निमन्त्रणा प्राप्त गर्नुहोस् साथी पहिलो जम्मा सफल भएमा, तपाईंले R$५ बोनस जित्न सक्नुहुन्छ। उदाहरणका लागि, यदि तपाईंले पहिलो जम्माको लागि १० जनालाई आमन्त्रित गर्नुभयो भने, तपाईंले R$५० कमाउन सक्नुहुन्छ। तपाईंले जति धेरै मानिसहरूलाई आमन्त्रित गर्नुहुन्छ, त्यति नै धेरै बोनसहरू प्राप्त गर्नुहुनेछ। तपाईं आफ्नो इतिहास हेर्न सक्नुहुन्छ र पदोन्नति पृष्ठमा दर्ता गर्न सक्नुहुन्छ। uses र उच्च आयोगहरू।',
  agent_step2:
    'यदि तपाईंका पाहुनाहरूले R$१ वा सोभन्दा बढी बाजी लगाए भने, तपाईंले पहिले नै उच्च आयोगको आनन्द लिन सक्नुहुन्छ! तपाईंले जीवनभर ५% सम्म कमिसन र जीवनभरको निमन्त्रणा कमाउन सक्नुहुन्छ! प्रणालीले अघिल्लो दिनको कमिसन भोलिपल्ट बिहान ७ बजे मिलाउनेछ।',
  agent_step2_1: 'कसरी प्राप्त गर्ने: लगइन - निमन्त्रणा प्रवर्द्धन - कमिसन सङ्कलन गर्नुहोस्',
  agent_table1: 'स्लट, फिशिङ र ब्लकचेनको लागि बेटिंग कमिसन दरहरू निम्नानुसार छन्:',
  agent_table1_1: 'ग्राहकले टपअप २० बेट २००',
  person: 'व्यक्ति',
  agent_table2_title1: 'सदस्य बेटिंग',
  agent_table2_title2: 'स्लट खेल मात्र',
  agent_table2_example:
    'उदाहरण: तपाईंसँग १०० सदस्यहरू छन्, र बाजीको कुल वास्तविक मूल्य प्रति दिन १० लाख रियास अनुमान गरिएको छ। त्यस दिन तपाईंले प्राप्त गर्ने कमिसन हो: १,०००,००० x १.२०% १२,००० रियास। मासिक १००,००० आम्दानी प्राप्त गर्न धेरै सजिलो छ।',
  reminder: 'रिमाइन्डर',
  agent_reminder:
    'एउटै आईपी, एउटै उपकरण, नाम, बैंक कार्ड र अन्य जानकारी भएको सदस्य खाताले एक पटक मात्र भाग लिन सक्छ, र नियम उल्लङ्घन गर्ने जो कोहीले पनि यो बोनसबाट लाभ उठाउन सक्नेछैन। वा समूह जफत गरिनेछ र खाताहरू स्थायी रूपमा फ्रिज गरिनेछ।',
  agent_step3_1:
    'गतिविधिहरूमा सदस्यहरूको सहभागिता प्रणालीद्वारा स्वचालित रूपमा गणना गरिन्छ, यदि कुनै आपत्ति छ भने, Jit993 द्वारा गरिएको विश्लेषणको नतिजा प्रबल हुनेछ।',
  agent_step3_2:
    'यदि तपाईंले आफ्नो सदस्य खाता/पासवर्ड बिर्सनुभयो भने, कृपया हाम्रो २४-घण्टा ग्राहक सेवा टोलीलाई सम्पर्क गर्नुहोस् ताकि तपाईंको खाता जानकारी पुन: प्राप्त गर्न सकियोस्।',
  agent_step3_3: 'Jit993 ले यो प्रचार कुनै पनि समय परिवर्तन, रोक, वा रद्द गर्ने अधिकार राख्दछ।',
  agent_step3_4: 'कमीशन बोनस प्राप्त गर्न योग्य एजेन्टहरूले उक्त बोनस नगद वा वालेटमा क्रेडिटको रूपमा प्राप्त गर्नेछन्।',
  agent_step3_5: 'फ्री गेम सुरक्षित नगर्नुहोस्, फ्री गेम किन्नुहोस्।',
  agent_step3_6: 'कुनै पनि बोनस र निक्षेपसँग संयोजन गर्न सकिँदैन',
  agent_step3_7: 'स्लट खेलको लागि मात्र उपलब्ध छ',
  promo_concluded: 'प्रोमो सकियो! भोलि फेरि जाँच गर्नुहोस्!',
  can_only_claim: '{{x}} देखि {{y}} {{z}} सम्म मात्र बोनस दाबी गर्न सकिन्छ समय',
  please_login: 'बोनस दाबी गर्न कृपया पहिले लगइन गर्नुहोस्!',
  back_to_home: 'घर फर्कनुहोस्',
  bonus_claimed: 'बोनस पहिले नै दाबी गरिएको छ!',
  wallet: 'वालेट',
  bank_bsb: `बैंक BSB`,
  pay_id: `PayID`,
  from_selected_promotion: 'चयन गरिएको पदोन्नतिबाट',
  helpful_links: 'उपयोगी लिङ्कहरू',
  platform: 'प्लेटफर्म',
  community: 'समुदाय',
  support: 'समर्थन',
  partnership_program: 'साझेदारी कार्यक्रम',
  help_center: 'मद्दत केन्द्र',
  sports_policy: 'खेलकुद नीति',
  aml_policy: 'एएमएल नीति',
  level: 'स्तर',
  back: 'पछाडि',
  network_error: 'नेटवर्क त्रुटि',
  we_have_sent_otp: 'हामीले तपाईंको फोन नम्बरमा OTP पठाएका छौं।',
  your_otp_expire: 'तपाईंको OTP को म्याद निम्न मितिमा सकिनेछ',
  didnt_receive: 'सन्देश प्राप्त गर्नुभएन?',
  send_again: 'फेरि पठाउनुहोस्',
  resend_again: 'फेरि पठाउनुहोस्',
  invalid_verification: 'अवैध प्रमाणीकरण कोड!',
  otp_expired: 'OTP को म्याद सकियो, कृपया आफ्नो फोन नम्बर पुन: प्रविष्ट गर्नुहोस् र फेरि प्रयास गर्नुहोस्!',
  otp_expired_redirect: 'OTP को म्याद सकियो! लगइनमा रिडिरेक्ट गरिँदै',
  captcha_check_failed: 'क्याप्चा जाँच असफल भयो!',
  verify_phonenumber: 'फोन नम्बर प्रमाणित गर्नुहोस्',
  send_otp: 'OTP पठाउनुहोस्',
  success_verification: 'तपाईंको फोन नम्बर प्रमाणित गरिएको छ!',
  press_get_code: 'SMS मार्फत प्रमाणिकरण कोड प्राप्त गर्न GET CODE बटन थिच्नुहोस्',
  otp_sent: 'प्रमाणीकरण कोड पठाइयो! जारी राख्न तलको प्रमाणीकरण कोड प्रविष्ट गर्नुहोस्।',
  get_code: 'कोड प्राप्त गर्नुहोस्',
  verify: 'प्रमाणित गर्नुहोस्',
  verification_code: 'प्रमाणीकरण कोड',
  otp_not_found: 'OTP प्रकार्य फेला परेन!',
  terms_n_conditions: `नियम र सर्तहरू`,
  the_activity_x_in: `गतिविधि {{x}} मा`,
  starts: `सुरु हुन्छ`,
  ends: `समाप्त हुन्छ`,
  list_of_winners: `विजेताहरूको सूची`,
  days: `दिनहरू`,
  hours: `घण्टा`,
  minutes: `मिनेट`,
  seconds: `सेकेन्ड`,
  total_amount_received: `कुल प्राप्त रकम`,
  claim: `दाबी गर्नुहोस्`,
  requirement_to_withdraw: `फिर्ता लिन आवश्यकता:`,
  total_bet_x: `कुल शर्त {{x}}`,
  x_of_y: `{{x}} को {{y}}`,
  no_balance: `ब्यालेन्स छैन`,
  fullname_note: `निकासी समस्याहरूबाट बच्नको लागि तपाईंको पूरा नाम तपाईंको बैंक खातासँग मेल खान्छ भनी सुनिश्चित गर्नुहोस्।`,
  number_exists: 'यो फोन नम्बर पहिले नै दर्ता गरिएको छ!',
  number_not_exists: 'यो फोन नम्बर दर्ता गरिएको छैन!',
  payment_draft:
    'यदि तपाईंले पहिले नै भुक्तानी गरिसक्नुभएको पुष्टि गर्नुभयो भने, भुक्तानी अझै प्रशोधन भइरहेको हुन सक्छ, त्यसैले कृपया केही समय पर्खनुहोस्।',
  live_chat: 'लाइभ च्याट',
  please_download_x_to_play: 'कृपया खेल्नको लागि {{x}} डाउनलोड गर्नुहोस्।',
  password: 'पासवर्ड',
  play_now: 'अहिले खेल्नुहोस्',
  vip_benefits: 'VIP लाभहरू',
  no_limits: 'कुनै सीमा छैन',
  no_limits_description:
    'हामी VIP क्लबका सबै खेलाडीहरूलाई अद्वितीय गेमिङ अवस्थाहरू सहित व्यक्तिगत VIP सेवाहरू प्रदान गर्दछौं। अब तपाईं कुनै पनि चिन्ता बिना खेल्न सक्नुहुन्छ! यो धेरै सरल छ - रोमाञ्चको लागि खेल्नुहोस्, आफ्नो गेमिङ सीपहरू सुधार गर्नुहोस्, आफ्नो समयको आनन्द लिनुहोस् र आफ्नो जित्ने अवसरहरूमा कुनै सीमा नराख्नुहोस्!',
  financial_privileges: 'वित्तीय विशेषाधिकारहरू',
  financial_privileges_description:
    'VIP क्लबले उच्च-गुणस्तरको VIP सेवा प्राप्त गर्न चाहने सबै खेलाडीहरूलाई स्वागत गर्दछ। हाम्रो वेबसाइटमा तपाईंको लागि विशेष विशेषाधिकार, विशेष पदोन्नति र सुविधाहरू उपलब्ध छन्! VIP खेलाडीको स्थितिले रेकर्ड-ब्रेकिंग छोटो अवधिमा उच्च निकासी सीमा अनलक गर्दछ! यसको आनन्द लिनुहोस्!',
  personal_manager: 'व्यक्तिगत प्रबन्धक',
  personal_manager_description:
    'VIP खेलाडी बन्दा तपाईं कुन कुन फाइदाहरू प्राप्त गर्न चाहनुहुन्छ? आफ्नो व्यक्तिगत प्रबन्धकसँग आफ्नो विचार साझा गर्नुहोस् र हाम्रो वेबसाइटमा अरू के के हेर्न पाउँदा खुसी हुनुहुनेछ हामीलाई थाहा दिनुहोस्! हामी उत्कृष्ट सुझावहरूको लागि सधैं खुला छौं!',
  vip_promotions: 'VIP प्रचारहरू',
  vip_promotions_description:
    'के तपाईं अझ राम्रा पदोन्नतिहरू प्राप्त गर्न चाहनुहुन्छ, ठूला VIP खेलाडीहरूले वफादारीको लागि इनामको रूपमा यी सबै र अन्य धेरै सुविधाहरूको आनन्द लिन्छन्! तिनीहरूमा सामेल हुनुहोस्!',
  become_vip: 'एक VIP बन्नुहोस्',
  play_the_way_you_want: 'आफूले चाहेअनुसार खेल्नुहोस्',
  join_vip_program: 'अहिले नै VIP कार्यक्रममा सामेल हुनुहोस्!',
  join_now: 'अहिले सम्मिलित हुनुहोस्',
  // TODO: Translate to other lang
  vip_club: 'वीआईपी क्लब',
  withdraw_limit: 'सीमा फिर्ता लिनुहोस्',
  cashback: 'क्यासब्याक',
  personal_account_manager: 'व्यक्तिगत खाता प्रबन्धक',
  dont_show_again: 'फेरि नदेखाउनुहोस्',
  next: 'अर्को',
  close: 'बन्द गर्नुहोस्',
  logout_confirmation: 'लगआउट पुष्टिकरण',
  are_you_sure_to_logout: 'के तपाईं लगआउट गर्न निश्चित हुनुहुन्छ?',
  must_start_with: `फोन नम्बर कम्तिमा १० अंकको हुनुपर्छ र (वैध नेटवर्क अर्थात् ९६, ९७ र ९८) बाट सुरु हुनुपर्छ।`,
  see_all: 'सबै हेर्नुहोस्',
  verified_by_play_protect: `Play Protect द्वारा प्रमाणित`,
  reviews: `२६ हजार समीक्षाहरू`,
  reviews_value: `४M+`,
  downloads: `डाउनलोडहरू`,
  rated_for: `१८+ को लागि मूल्याङ्कन गरिएको`,
  install: `स्थापना गर्नुहोस्`,
  add_to_wishlist: `इच्छासूचीमा थप्नुहोस् स्थापना गर्नुहोस्`,
  about_this_app: `यस एपको बारेमा`,
  app_description_1: `नेपालको प्रमुख अनलाइन क्यासिनो प्लेटफर्म Jit993 मा स्वागत छ, जहाँ उत्साह र जितको अवसर कहिल्यै रोकिँदैन। तपाईं क्लासिक क्यासिनो खेलहरूको प्रशंसक हुनुहुन्छ वा आधुनिक, उच्च-दांव बेटिंगको, हामी
सबैको लागि केहि प्रस्ताव गर्छौं। स्लटहरू,
ब्ल्याकज्याक, रूलेट, पोकर, र थप सहित हाम्रा खेलहरूको विस्तृत दायराको रोमाञ्च अनुभव गर्नुहोस्—सबै तपाईंको मोबाइल उपकरणको आरामबाट।`,
  app_description_2: `Jit993 मा, हामी तपाईंको सुरक्षा र गेमिङ अनुभवलाई प्राथमिकता दिन्छौं। हाम्रो प्लेटफर्म पूर्ण रूपमा इजाजतपत्र प्राप्त र सुरक्षित छ,
सधैं निष्पक्ष खेल र जिम्मेवार गेमिङ सुनिश्चित गर्दै। हामी तपाईंको
व्यक्तिगत जानकारी सुरक्षित गर्न र छिटो निक्षेप, द्रुत निकासी, र
२४/७ ग्राहक समर्थनको साथ निर्बाध गेमिङ अनुभव प्रदान गर्न उन्नत प्रविधि प्रयोग गर्छौं।`,
  why_choose_brand: `Jit993 किन रोज्ने?`,
  reason_1: `शीर्ष खेल प्रदायकहरूबाट खेलहरूको विशाल संग्रह`,
  reason_2: `सजिलो नेभिगेसनको साथ प्रयोगकर्ता-अनुकूल इन्टरफेस`,
  reason_3: `तपाईंको लागि मात्र तयार पारिएको विशेष बोनस र प्रमोशनहरू`,
  reason_4: `छिटो र सुरक्षित कारोबारको लागि सुरक्षित भुक्तानी विकल्पहरू`,
  reason_5: `तपाईंको रुचि अनुरूप नेपाली र अंग्रेजीमा उपलब्ध छ।`,
  app_description_3: `आज नै हजारौं सन्तुष्ट खेलाडीहरूसँग सामेल हुनुहोस् र नेपालको सबैभन्दा भरपर्दो अनलाइन क्यासिनो अनुभवमा भाग लिनुहोस्! तपाईं यहाँ खेलको रोमाञ्चको लागि हुनुहुन्छ वा ठूलो जित्ने मौकाको लागि, Jit993 तपाईंको अनन्त मनोरञ्जनको प्रवेशद्वार हो।`,
  optional: 'ऐच्छिक',
  app_download: `एप डाउनलोड गर्नुहोस्`,
  download_message: `आज हाम्रो एप डाउनलोड गर्नुहोस्!`,
  please_select_lang: 'कृपया एउटा भाषा चयन गर्नुहोस्',
  before_that: 'त्यसअघि',
  how_to_get_referral_bonus: 'रेफरल फ्रेन्ड बोनस कसरी प्राप्त गर्ने?',
  steps_to_claim: 'बोनस प्राप्त गर्ने चरणहरू',
  share_your_referral_code:
    '१. तपाईंको रेफरल कोड फेसबुक, ट्विटर, वा व्हाट्सएपमार्फत साथीलाई खाता दर्ता गर्नको लागि साझा गर्नुहोस्।',
  after_friend_register:
    '२. साथीले Jit993 मा खाता दर्ता गरेपछि, रेफर गर्ने र रेफर गरिएको सदस्य दुवैले बोनस दाबी गर्न निक्षेप गर्नुपर्नेछ।',
  refer_a_friend_bonus: '३. रेफर फ्रेन्ड बोनस गणना:',
  turnover_played: 'टर्नओभर खेलिएको × कमिसन % = रेफरल फ्रेन्ड बोनस',
  example: 'उदाहरण:',
  turnover_formula_x: 'टर्नओभर (1,000,000) × 0.002% (कमिसन %) = 2,000{{x}}',
  note_bonus_only: '*नोट: बोनस अर्को दिन बिहान १२:०० बजेपछि मात्र दाबी गर्न सकिन्छ।',
  note_bonus_only_x: '*नोट: बोनस अर्को दिन {{x}} पछि मात्र दाबी गर्न सकिन्छ।',
  access_dashboard: '४. लाभ, कमिसन स्तर, दाबी इतिहास, र डाउनलाइन जाँच गर्न ड्यासबोर्ड पहुँच गर्नुहोस्।',
  click_this_button_to_claim: 'रेफरल फ्रेन्ड बोनस दाबी गर्न यो बटन क्लिक गर्नुहोस्।',
  commision_tier: 'कमिसन स्तर',
  member_downline: 'सदस्य डाउनलाइन',
  affiliates: 'संबद्धहरू',
};

export default en;
